import * as React from 'react';

import { Icon } from '@/shared/types/icon';

const Facebook = ({ size = 24, ref, ...props }: Icon & { ref?: React.Ref<SVGSVGElement> }) => {
  return (
    <svg
      {...props}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9989 0C5.24054 0 0 4.95256 0 11.639C0 15.1367 1.43387 18.1604 3.76767 20.2482C3.96265 20.4222 4.08264 20.6682 4.08864 20.9321L4.15463 23.068C4.17563 23.7489 4.87757 24.1929 5.50151 23.9169L7.8833 22.867C8.08428 22.777 8.31226 22.762 8.52524 22.819C9.62015 23.119 10.784 23.2809 11.9989 23.2809C18.7573 23.2809 23.9979 18.3284 23.9979 11.642C23.9979 4.95556 18.7573 0 11.9989 0Z"
        fill="url(#paint0_radial_2144_3232)"
      />
      <path
        d="M4.79315 15.0437L8.31784 9.45218C8.87879 8.56126 10.0787 8.34228 10.9216 8.97222L13.7264 11.075C13.9843 11.267 14.3383 11.267 14.5933 11.072L18.3789 8.19829C18.8829 7.81432 19.5428 8.42027 19.2069 8.95722L15.6792 14.5457C15.1182 15.4366 13.9183 15.6556 13.0754 15.0257L10.2707 12.9229C10.0127 12.7309 9.65872 12.7309 9.40374 12.9259L5.61808 15.7996C5.11412 16.1836 4.45418 15.5806 4.79315 15.0437Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2144_3232"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.61959 23.8672) scale(26.1481 26.148)"
        >
          <stop stopColor="#0099FF" />
          <stop offset="0.6098" stopColor="#A033FF" />
          <stop offset="0.9348" stopColor="#FF5280" />
          <stop offset="1" stopColor="#FF7061" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default Facebook;
